const PromotionRetentionLabels = {
  // base_business_partner_id
  description: { label: 'Descripción', type: 'string', forceShow: true, itemWidth: { xl: 6 } },
  external_code: { label: 'Cod. Externo', type: 'string' },
  bonification_type: {
    label: 'Tipo Bonificación',
    type: 'combo',
    forceShow: true,
    values: [
      { value: 'P', text: 'Producto' },
      { value: 'D', text: 'Descuento %' },
      { value: 'S', text: 'Descuento S/' },
    ],
  },
  evaluation_type: {
    label: 'Tipo Evaluación',
    type: 'combo',
    forceShow: true,
    values: [
      { value: 'P', text: 'Producto' },
      { value: 'S', text: 'Proveedor' },
      { value: 'C', text: 'Categoria' },
      { value: 'F', text: 'Familia' },
    ],
  },
  state: {
    label: 'Estado',
    type: 'combo',
    forceShow: true,
    values: [
      { value: 'P', text: 'Aprobado' },
      { value: 'V', text: 'Vigente' },
      { value: 'L', text: 'Liquidado' },
      { value: 'I', text: 'Inactivo' },
      { value: 'G', text: 'Generado' },
      { value: 'N', text: 'Nuevo' },
      { value: 'C', text: 'Cancelado' },
      { value: 'R', text: 'Retenido' },
    ],
  },
  start_date: { label: 'Fecha Inicio', type: 'date', forceShow: true },
  end_date: { label: 'Fecha Fin', type: 'date', forceShow: true },
  condition: {
    label: 'Condición',
    type: 'combo',
    values: [
      { value: 'Q', text: 'Cantidad' },
      { value: 'M', text: 'Monto' },
    ],
  },
  origin: {
    label: 'Origen',
    type: 'combo',
    values: [
      { value: 'E', text: 'Externo' },
      { value: 'I', text: 'Interno' },
    ],
  },

  sale_condition: {
    label: 'Condición Venta',
    type: 'combo',
    values: [
      { value: 'C', text: 'Contado' },
      { value: 'R', text: 'Crédito' },
      { value: 'A', text: 'Ambos' },
    ],
  },
  // quantity
  limit_promotion: { label: 'Lím. Promoción', type: 'number' },
  // advance_promotion
  limit_amount: { label: 'Límite Monto', type: 'number' },
  // advence_amount
  limit_ume: { label: 'Límite Umes', type: 'number' },
  // advance_ume
  // limit_costumer = 'Límite cliente', // No usadoo
  // advance_costumer
  // user
  // user_authorized
  // user_inaction
  // compensation_type = '', // No usado
  // document_liquidate
  // serie_liquidate
  // num_liquidate
  // created_at
  // updated_at
  // deleted_at
  // customer_limit = 'Límite cliente',
  limit_per_customer: { label: 'Límite cliente', type: 'number' },
  // parent_promotion_id
  new_customer_date: { label: 'Solo clientes nuevos', type: 'date' },
  only_business_lines: {
    label: 'Sólo giros de negocio',
    type: 'bool',
    parseChecked: (value) => value === 'Y',
  },
  // limit_customer_type
  evaluate_um: { label: 'Evaluar UM', type: 'bool' },
  surprise_plan: { label: 'Plan sorpresa', type: 'bool' },
  // account_combo_product
  // duplicated_from_id
  evaluar_mayorista: { label: 'Evaluar mayorista', type: 'bool' },
};

export default PromotionRetentionLabels;
